<div class="error">
  <nx-icon name="product-danger" class="error-icon"></nx-icon>
  <div class="error-message">
    <h3 nxHeadline="subsection-large">{{ header ?? 'common.error.title' | translate }}</h3>
    <p nxCopytext="normal">{{ messageToShow | translate }}</p>
  </div>
  <div class="error-actions" *ngIf="showTryAgain">
    <button nxButton="secondary small-medium" (click)="tryAgain.emit()">{{ 'common.error.tryAgain' | translate }}</button>
  </div>
</div>
